import { sizeSpacing06 } from '@resultadosdigitais/tangram-design-tokens';
import { convertUnitToInt } from '../helper';
const config = {
  size: 300,
  offset: convertUnitToInt(sizeSpacing06)
};
export default config;